export const overlayPositionOnCollapsedMenu = [
  {
    originX: 'end' as const,
    originY: 'top' as const,
    overlayX: 'start' as const,
    overlayY: 'top' as const,
    offsetX: 20,
  },
  {
    originX: 'end' as const,
    originY: 'center' as const,
    overlayX: 'start' as const,
    overlayY: 'center' as const,
    offsetX: 20,
  },
  {
    originX: 'end' as const,
    originY: 'bottom' as const,
    overlayX: 'start' as const,
    overlayY: 'bottom' as const,
    offsetX: 20,
  },
  {
    originX: 'start' as const,
    originY: 'top' as const,
    overlayX: 'end' as const,
    overlayY: 'top' as const,
    offsetX: -20,
  },
];

export const overlayPositionOnExpandedMenu = [
  {
    originX: 'start' as const,
    originY: 'bottom' as const,
    overlayX: 'start' as const,
    overlayY: 'top' as const,
    offsetY: 8,
  },
  {
    originX: 'end' as const,
    originY: 'bottom' as const,
    overlayX: 'end' as const,
    overlayY: 'top' as const,
    offsetY: 8,
  },
  {
    originX: 'center' as const,
    originY: 'bottom' as const,
    overlayX: 'center' as const,
    overlayY: 'top' as const,
    offsetY: 8,
  },
];

/**
 * User action types
 */
export const USER_ACTIONS = {
  PROFILE: 'profile',
  LOGOUT: 'logout',
} as const;

export type UserAction = (typeof USER_ACTIONS)[keyof typeof USER_ACTIONS];

/**
 * Keyboard codes for navigation
 */
export const KEYBOARD_CODES = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
} as const;
